import tenant from '@/services/TenantService';
import { useEffect, useState } from 'react';
import useTenantStore from '@/store/tenant';

export default function useTenantQuery(schema) {
  const { upsert } = useTenantStore();
  const [isPending, setIsPending] = useState(false);
  const [error, setError] = useState(null);

  const data = Object.values(useTenantStore((state) => state[schema]) || {});

  async function fetchData() {
    setIsPending(true);
    try {
      const { data } = await tenant.get(`/${schema}`);
      if (Array.isArray(data)) {
        data.forEach((item) => upsert(item, schema));
      } else {
        upsert(data);
      }
    } catch (error) {
      setError(error);
    } finally {
      setIsPending(false);
    }
  }

  useEffect(() => {
    fetchData();
  }, [schema]);

  const revalidate = () => fetchData();

  return { data, isPending, error, revalidate };
}
